import { Component, OnInit, Input } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { LegendModel } from './legend.model';

@Component({
  selector: 'app-legend',
  templateUrl: './legend.component.html',
  styleUrls: ['./legend.component.scss']
})
export class LegendComponent implements OnInit {

  @Input('data') data: Array<LegendModel>;
  constructor() { }

  ngOnInit() {
  }

}
